'use client'

import PropTypes from 'prop-types'
import MUITypography from '@mui/material/Typography'
import MUIStack from '@mui/material/Stack'

export const DateSeparator = ({ dateToDisplay = 'Date', textColor, sx }) => {
  return (
    <MUIStack
      data-testid="DateSeparator"
      direction="row"
      alignItems="center"
      justifyContent="center"
      sx={{ position: 'relative', width: '100%', mb: 6, mt: 6, ...sx }}
    >
      <MUITypography
        sx={{
          position: 'sticky',
          top: '20px',
          zIndex: 2,
          backgroundColor: 'white',
          border: '0.5px solid #D8DCE5',
          borderRadius: '27px',
          padding: '2px 12px 5px',
          minWidth: '98px',
          height: '22px',
          textAlign: 'center',
          mb: 0,
          color: textColor
        }}
        variant="subtitle2"
      >
        {dateToDisplay}
      </MUITypography>
      <hr
        style={{
          width: '100%',
          position: 'absolute',
          borderColor: 'transparent',
          borderTopColor: 'transparent',
          borderBottomColor: '#D8DCE5',
          borderWidth: '0.5px',
          zIndex: 1,
          height: '0.5px',
          margin: 0
        }}
      />
      <div
        style={{ backgroundColor: 'white', width: '100%', height: '11px', position: 'absolute', top: 0, left: 0 }}
      ></div>
    </MUIStack>
  )
}

DateSeparator.propTypes = {
  dateToDisplay: PropTypes.string,
  textColor: PropTypes.string,
  sx: PropTypes.object
}
